/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Kiotviet_Link_Success_ManyInputs */

const vi_kiotviet_link_success_many = /** @type {(inputs: Kiotviet_Link_Success_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã nối sản phẩm cho ${i?.count} dòng`)
};

/**

* @param {Kiotviet_Link_Success_ManyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const kiotviet_link_success_many = /** @type {((inputs: Kiotviet_Link_Success_ManyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kiotviet_Link_Success_ManyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_kiotviet_link_success_many(inputs)
});